// extracted by mini-css-extract-plugin
export default {"container":"BooleanAnswerButtons_container__NDZLe","button":"BooleanAnswerButtons_button__UYeoE"};